import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Col, Grid } from 'components/grid'

import { COMPLIANCE_EMAIL } from '../documents'

import * as S from './styles'

const IMAGES_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/integrity-program`

const seals = [
  { id: 'empresa-limpa', src: `${IMAGES_PATH}/selo-empresa-limpa.webp`, alt: 'Selo Empresa Limpa', w: 186, h: 81 },
  { id: 'pacto-brasil', src: `${IMAGES_PATH}/selo-pacto-brasil.webp`, alt: 'Selo Pacto Brasil', w: 200, h: 126 },
  { id: 'pro-etica', src: `${IMAGES_PATH}/selo-pro-etica.webp`, alt: 'Selo Empresa Pró-Ética', w: 64, h: 95 }
]

const SeeMore: FC = memo(() => (
  <S.Section $bg="medium">
    <Grid col={{ phone: 1, tablet: 1 }}>
      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <S.TitleWrapper>
          <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-default)">
            Veja o que mais preparamos para você
          </Text>
        </S.TitleWrapper>

        <S.Cards>
          <S.DoubtsCard>
            <Text size="heading4" color="var(--colors-neutral-text-contrast-default)">
              Ainda tem dúvidas?
            </Text>
            <Text size="body2" color="var(--colors-neutral-text-contrast-default)">
              Você pode entrar em contato com a gente caso tenha alguma dúvida sobre o nosso Programa de Integridade
              pelo e-mail <S.Mail href={`mailto:${COMPLIANCE_EMAIL}`}>{COMPLIANCE_EMAIL}</S.Mail>.
            </Text>
          </S.DoubtsCard>

          <S.SealsCard>
            <Text size="heading4" color="var(--colors-neutral-text-default)">
              Selos e Parcerias
            </Text>
            <Text size="body2" color="var(--colors-neutral-text-default)">
              O CashMe tem parcerias com instituições que, assim como nós, prezam por um ambiente de negócios íntegro e
              transparente.
            </Text>

            <S.Seals>
              {seals.map(({ id, src, alt, w, h }) => (
                <S.Seal key={id}>
                  <NextImage src={src} alt={alt} width={w} height={h} />
                </S.Seal>
              ))}
            </S.Seals>
          </S.SealsCard>
        </S.Cards>

        <S.Footnote>
          <Text size="heading4" color="var(--colors-neutral-text-default)">
            A CashMe não realiza ações de patrocínios e doações para entidades públicas.
          </Text>
        </S.Footnote>
      </Col>
    </Grid>
  </S.Section>
))

SeeMore.displayName = 'SeeMore'

export default SeeMore
